<template>
  <div>
    <PairSpin :show="isShowPairSpin"/>
    <Content class="cust-content">
      <Row class="content-table-wrapper">
        <Row>
          <Table :columns="tableColumns" :data="sysLogSqlList" :loading="isListLoading" stripe border />
        </Row>
      </Row>
    </Content>
  </div>
</template>

<script>
import * as Utils from '@/utils'
import SearchWrapper from '@/components/wrapper/SearchWrapper'

export default {
  components: {
    // Title
    SearchWrapper
  },
  props: {
    compId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    projId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    actionId: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    },
    source: {
      type: String,
      require: true,
      default: () => {
        return 'TRANS' // TRANS-成本栏结算人的凭证明细页面， INVOICE-成本票台账页面
      }
    }
  },
  data() {
    return {
      fixedHeader: true,
      tableHeight: 400,
      isListLoading: false,
      isShowPairSpin: false,
      isDeleteLoading: false,
      parentPath: '',
      parentTitle: '',
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      tableColumns: [
        {
          title: '#',
          key: 'sqlBody',
          align: 'center',
          width: 60,
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            return [
              h('span', {
                prop: {
                  type: 'text'
                }
              }, (params.index + 1))
            ]
          }
        },
        {
          title: this.$t('module.audit.syslogsql.info.sqlBody'),
          key: 'sqlBody',
          align: 'left',
          // width: 300,
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.audit.syslogsql.info.sqlParam'),
          key: 'sqlParam',
          align: 'left',
          width: 300,
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.audit.syslogsql.info.userId'),
          key: 'userLegalName',
          width: 90,
          align: 'center',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.audit.syslogsql.info.startTime'),
          key: 'startAndTotalTime',
          width: 260,
          align: 'center',
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            return [
              h('span', {
                prop: {
                  type: 'text'
                }
              }, (Utils.formatDateToAll(params.row.startTime)))
            ]
          }
        }
      ],
      END_DATA: null
    }
  },
  computed: {
    sysLogSqlList() {
      return this.$store.state.sysLogSqlManage.sysLogSqlList
    },
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    formatI18nValue(prefix, value) {
      return value ? this.$t(prefix + value) : null
    },
    initFormValue() {
    },
    cleanForm() {
      this.$store.commit('sysLogSqlManage/updateSysLogSqlListEmpty')
    },
    getKeyParam() {
      return { projId: this.projId, compId: this.compId }
    },
    isActiveItem: Utils.isActiveItem,
    // isUsedItem: Utils.isUsedItem,
    formatDate: Utils.formatDate,
    formatDateToDay: Utils.formatDateToDay,
    formatDateToMonth: Utils.formatDateToMonth,
    formatDateToMonthInt: Utils.formatDateToMonthInt,
    formatIntMonth: Utils.formatIntMonth,
    findItemDescrByValue: Utils.findItemDescrByValue,
    // parseDate: Utils.parseDate,
    getMonthFirstDay: Utils.getMonthFirstDay,
    getMonthLastDay: Utils.getMonthLastDay,
    formatThousandthNumber: Utils.formatThousandthNumber,
    parserThousandthNumber: Utils.parserThousandthNumber,
    async refreshList() {
      this.isListLoading = true
      this.$store.commit('sysLogSqlManage/updateSysLogSqlListEmpty')
      const result = await this.$store.dispatch('sysLogSqlManage/findSysLogSqlListByActionId', {...this.getKeyParam(), actionId: this.actionId, ...Utils.getCodeParam(this.$route)})
      if (result.success) {
        this.$store.commit('sysLogSqlManage/updateSysLogSqlList', result.data)
      }
      this.isListLoading = false
    },
    async goSearch() {
      this.isShowPairSpin = true
      this.doSearchProcess()
      this.isShowPairSpin = false
    },
    async doSearchProcess() {
      await this.refreshList()
    },
    END_METHODS() {}
  },
  async mounted() {
    // console.info('SysLogSqlCard open')
    // console.info('compId: ', this.compId)
    // console.info('projId: ', this.projId)
    // console.info('id: ', this.id)
    this.cleanForm()

    this.initFormValue()

    await this.goSearch()
  },
  async destroyed() {
    // debugger
    this.cleanForm()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/audit/SysLogSqlCard.vue